module.exports = __webpack_public_path__ + "static/media/ring-text.5012b731.png";